<template>
  <div class="policy">
    <a v-on:click="back">
      <img
        src="/static/images/icons/black/back.png"
        alt=""
        class="back_image_button"
        title=""
      />
    </a>
    <h2>Privacy Policy</h2>
    <p class="title uppercase">
      Introduction
    </p>
    <p>
      WebSpin 360, LLC (“WebSpin”) respects your privacy and is committed to
      protecting it through our compliance with this Privacy Policy (“Policy”).
      This Policy describes the types of information we may collect from you or
      that you may provide when you visit any SalesRater, LikeMyCar or
      Build-a-Brand website, digital business card, or mobile application
      (“App”), when you download any App, and/or when you sign up for any
      service with us, as well as our practices for collecting, using,
      maintaining, protecting, and disclosing that information.
    </p>
    <p>This Policy applies to information we collect:</p>
    <ul>
      <li>On this Website;</li>
      <li>
        In email, text, and/or any other electronic messages between you and us;
      </li>
      <li>
        Through any mobile and desktop applications you download from this
        Website or from a third party site, which provide dedicated
        non-browser-based interaction between you and us; or
      </li>
      <li>
        When you interact with any advertising and applications on third-party
        websites and services, if those applications or advertising include
        links to this Website or via our App.
      </li>
    </ul>
    <br />
    It does <strong>not</strong> apply to information collected by:
    <ul>
      <li>
        WebSpin offline or through any other means, including on websites
        operated by any third party (including our affiliates and subsidiaries);
        or
      </li>
      <li>
        Any third party (including our affiliates and subsidiaries), including
        through any application or content (including advertising) that may link
        to or be accessible from or on the Website.
      </li>
    </ul>

    <p>
      Please read this Policy carefully to understand our policies and practices
      regarding your information and how we will treat it. If you do not agree
      with our policies and practices, your choice is not to use our Website or
      download our App. By accessing or using this Website, or downloading our
      App, you agree to this Policy. This Policy may change from time to time
      and your continued use of this Website or our App after we make changes is
      deemed to be acceptance of those changes, so please check the Policy
      periodically for updates.
    </p>
    <p class="title uppercase">
      Information collected automatically
    </p>
    <p>We automatically collect the following:</p>
    <ul>
      <li>Your Internet protocol (IP) address and domain name;</li>
      <li>
        The type of browser and operating system you use to access the WebSpin
        website and any domain names that point to sites therein;
      </li>
      <li>The date and time you visited this site;</li>
      <li>
        The Web pages or services you accessed while at our website and any
        domain names that point to sites therein.
      </li>
    </ul>
    <p class="title uppercase">
      Information you provide
    </p>
    <p>
      Information collected when you register or fill out any forms on our
      Website, download our App, participate in any survey or provide other
      feedback, send an e-mail, request information, or perform some other
      transaction online will be used solely for the stated purpose. This
      purpose may be to respond to you; to personalize your experience; to
      process transactions or purchases; to administer a contest, promotion,
      survey, or other features of the Website or App; to improve our Website,
      our App, or our services; or to forward the information you provide
      internally for appropriate action. Survey information may be used to
      improve services and better gauge customer sentiment on issues ranging
      from services to the design of our Website or App. To the greatest extent
      permitted by law, information will be shared internally and only with
      approved vendors on a need-to-know basis.
    </p>
    <p>
      WebSpin has taken measures to safeguard the integrity of customer-provided
      information in order to prevent unauthorized access. These measures are
      designed to prevent corruption of data, block unauthorized access, and
      provide reasonable protection of private information in our possession.
      This should not be construed as a warranty of the security of information
      provided via the Website, or any domain names that point to sites therein,
      or the App. After any transaction, your private information, including
      payment information, will not be stored on our servers.
    </p>
    <p class="title uppercase">
      Use of information
    </p>
    <p>
      Except as expressly provided in this Policy, we do not share Personal
      Information (defined as your address, email address, phone number, fax
      number, IP address, social security number, billing or payment
      information, account number, password or any other information that might
      identify you personally) with other organizations for their commercial or
      marketing purposes, nor will we intentionally disclose your Personal
      Information to third parties. We do, however, reserve the right to
      disclose Personal Information:
    </p>
    <ul>
      <li>
        When authorized by you or when necessary to provide a service you have
        requested;
      </li>
      <li>
        To communicate with you about issues related to your account or any
        request for service;
      </li>
      <li>
        When necessary to comply with an order of a court, governmental agency,
        regulatory authority, or when requested in writing by law enforcement
        pursuant to a valid subpoena;
      </li>
      <li>
        To investigate and address system problems and to protect the security
        of our Website, App, or the products and services we provide; or
      </li>
      <li>
        To a purchaser in connection with the sale, assignment, or other
        transfer of all or part of our business or company.
      </li>
    </ul>
    <p class="title uppercase">
      Linked sites 
    </p>
    <p>
      This website contains links to other sites external to our Website. Please
      be aware that the Internet sites available through these links, and the
      materials that you may find there, are not under our control. We cannot
      and do not make any representation about these sites or the materials
      and/or information available there. The fact that we have made these links
      available is not an endorsement or recommendation of any of these sites or
      any materials found there.
    </p>
    <p>
      WebSpin is NOT responsible for the privacy practices of those sites when
      linked to them through our Website or App. Linked sites may send their own
      cookies to users, collect data, or solicit personal information. Visitors
      should read the privacy policies or privacy statements of those sites
      where they collect personally identifiable information. This disclaimer
      pertains only to the website(s) under our sole control.
    </p>

    <p class="title uppercase">
      Do not track signals
    </p>
    <p>
      Under California law, California residents are entitled to information
      concerning how we respond to “Do Not Track” settings on user’s browser
      settings. We do not take action in response to “Do Not Track” settings or
      signals.
    </p>
    <p class="title uppercase">
      Consent
    </p>
    <p>
      By using this site or downloading our App, you signify your consent to
      this Policy. If you do not agree to this Policy, please do not use this
      site or download our App.
    </p>
    <p class="title uppercase">
      Updates and revisions
    </p>
    <p>
      We reserve the right, in its sole discretion, to update, change, modify,
      add or remove portions of this Policy from time to time. Changes to our
      disclaimer will be promptly disclosed here so that you can be fully
      informed about the privacy protections we provide.
    </p>
    <p class="title">
      Correcting, Updating, Deleting Your Information
    </p>
    <p>
      If your personal information changes, or if you no longer desire our
      service, you may correct, update, amend, delete/remove, ask to have it
      removed from a public forum or testimonial on our site by contacting us
      via one of the methods listed below. We will respond to your request
      within 30 days.
    </p>
    <p class="title">
      Data Retention
    </p>
    <p>
      We will retain your information for as long as your account is active or
      as needed to provide you services. We will retain and use your information
      as necessary to comply with our legal obligations, resolve disputes, and
      enforce our agreements.
    </p>
    <p class="title">
      External Links
    </p>
    <p>
      Our Web sites contain links to other sites. Any such links are provided
      solely as a convenience to you. WebSpin is not responsible for the privacy
      practices or the content of such Web sites. To help ensure the protection
      of your privacy, we recommend that you review the privacy policy of any
      site you visit via a link from one of our Web sites.
    </p>
    <p class="title">
      Public Forums
    </p>
    <p>
      Our Websites may make blog comment areas, chat rooms, forums, message
      boards, and/or news groups available to its users at various times. Please
      remember that, unless otherwise stated, any information that is disclosed
      in these areas becomes public information and you should exercise caution
      when deciding to disclose your personal information in these areas.
    </p>
    <p class="title">Testimonials</p>
    <p>
      With your consent, we may post your testimonial along with your name. If
      you wish to update or delete your testimonial, you can contact us via one
      of the methods listed below.
    </p>
    <p class="title">Social Media Widgets</p>
    <p>
      Our Web site includes Social Media Features, such as the Facebook Like
      button. These Features may collect your IP address, which page you are
      visiting on our site, and may set a cookie to enable the Feature to
      function properly. Social Media Features are either hosted by a third
      party or hosted directly on our Site. Your interactions with these
      Features are governed by the privacy policy of the company providing it.
    </p>
    <p class="title">Security</p>
    <p>
      The security of your personal information is important to us. We follow
      generally accepted standards to protect the personal information submitted
      to us, both during transmission and once we receive it. No method of
      transmission over the Internet, or method of electronic storage, is 100%
      secure, however. Therefore, we cannot guarantee its absolute security.
    </p>
    <p class="title">Opt-out Procedures</p>
    <p>
      Out of respect for your privacy, you may choose to stop receiving our
      newsletter or marketing emails by following the unsubscribe instructions
      included in these emails or you can contact us via one of the methods
      listed below.
    </p>
    <p class="title">Browser-Based Do Not Track</p>
    <p>
      Some browsers incorporate a "Do Not Track" (DNT) feature that, when turned
      on, signals to websites and online services that you do not want to be
      tracked. Because there is not yet an accepted standard for how to respond
      to a DNT signal, we do not currently respond to DNT signals on this
      website or on websites where we provide advertisements, content, or other
      services.
    </p>
    <p class="title">Children's Privacy</p>
    <p>
      This website is not directed to children under the age of thirteen, and we
      do not knowingly collect personal information from children under the age
      of thirteen on the site. If we become aware that we have inadvertently
      received personal information from a visitor under the age of thirteen on
      the site, we will delete the information from our records.
    </p>
    <p class="title">Your California Privacy Rights</p>
    <p>
      This PRIVACY NOTICE FOR CALIFORNIA RESIDENTS supplements the information
      contained in the Privacy Statement of WebSpin and applies solely to
      consumers who reside in the State of California ("consumers" or "you"). We
      adopt this notice to comply with the California Consumer Privacy Act of
      2018 ("CCPA") and other California privacy laws. Any terms defined in the
      CCPA have the same meaning when used in this notice.
    </p>
    <p class="title">Information We Collect</p>
    <p>
      We collect information that identifies, relates to, describes, references,
      is capable of being associated with, or could reasonably be linked,
      directly or indirectly, with an individual consumer, household, or device
      ("personal information"). We have collected the following categories of
      personal information from consumers within the last twelve (12) months:
      The following examples are taken directly from the California Consumer
      Privacy Act, WebSpin collects at least one of the example items from each
      category. Category - Examples Collected
    </p>
    <ul class="simple">
      <li>
        <p>
          A. Identifiers. A real name, alias, postal address, unique personal
          identifier, online identifier, Internet Protocol address, email
          address, account name, Social Security number, driver's license
          number, passport number, or other similar identifiers. YES
        </p>
      </li>
      <li>
        <p>
          B. Personal information categories listed in the California Customer
          Records statute (Cal. Civ. Code § 1798.80(e)). A name, signature,
          Social Security number, physical characteristics or description,
          address, telephone number, passport number, driver's license or state
          identification card number, insurance policy number, education,
          employment, employment history, bank account number, credit card
          number, debit card number, or any other financial information, medical
          information, or health insurance information. Some personal
          information included in this category may overlap with other
          categories. YES
        </p>
      </li>
      <li>
        <p>
          C. Protected classification characteristics under California or
          federal law. Age (40 years or older), race, color, ancestry, national
          origin, citizenship, religion or creed, marital status, medical
          condition, physical or mental disability, sex (including gender,
          gender identity, gender expression, pregnancy or childbirth and
          related medical conditions), sexual orientation, veteran or military
          status, genetic information (including familial genetic information).
          YES
        </p>
      </li>
      <li>
        <p>
          D. Commercial information. Records of personal property, products or
          services purchased, obtained, or considered, or other purchasing or
          consuming histories or tendencies. YES
        </p>
      </li>
      <li>
        <p>
          E. Biometric information. Genetic, physiological, behavioral, and
          biological characteristics or activity patterns used to extract a
          template or other identifier or identifying information, such as
          fingerprints, faceprints, voiceprints, iris or retina scans,
          keystroke, gait, or other physical patterns, and sleep, health, or
          exercise data. NO
        </p>
      </li>
      <li>
        <p>
          F. Internet or other similar network activity. Browsing history,
          search history, and information on a consumer's interaction with a
          website, application, or advertisement. YES
        </p>
      </li>
      <li>
        <p>G. Geolocation data. Physical location or movements. YES</p>
      </li>
      <li>
        <p>
          H. Sensory data. Audio, electronic, visual, thermal, olfactory, or
          similar information. NO
        </p>
      </li>
      <li>
        <p>
          I. Professional or employment-related information. Current or past job
          history or performance evaluations. YES
        </p>
      </li>
      <li>
        <p>
          J. Non-public education information (per the Family Educational Rights
          and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).
          Education records directly related to a student maintained by an
          educational institution or party acting on its behalf, such as grades,
          transcripts, class lists, student schedules, student identification
          codes, student financial information, or student disciplinary records.
          NO
        </p>
      </li>
      <li>
        <p>
          K. Inferences drawn from other personal information. Profile
          reflecting a person's preferences, characteristics, psychological
          trends, predispositions, behavior, attitudes, intelligence, abilities,
          and aptitudes. YES
        </p>
      </li>
    </ul>
    <p>
      We obtain the categories of personal information listed above from the
      following categories of sources: Directly from our customers or their
      agents. For example, from documents that our clients provide to us related
      to the services for which they engage us. Indirectly from our clients or
      their agents. For example, through information we collect from our clients
      in the course of providing services to them. Directly and indirectly from
      activity on our client’s website. From third-parties that interact with us
      in connection with the services we offer and/or perform.
    </p>
    <p class="title">Sharing Personal Information</p>
    <p>
      We may disclose your personal information to a third party for a business
      purpose. When we disclose personal information for a business purpose, we
      enter a contract that describes the purpose and requires the recipient to
      both keep that personal information confidential and not use it for any
      purpose except performing the contract. In the preceding twelve (12)
      months, we have disclosed the following categories of personal information
      for a business purpose:
    </p>
    <ul class="simple">
      <li>Category A: Identifiers.</li>
      <li>
        Category B: California Customer Records personal information categories.
      </li>
      <li>
        Category D: Protected classification characteristics under California or
        federal law.
      </li>
      <li>Category F: Internet or other similar network activity.</li>
      <li>Category I: Professional or employment-related information.</li>
      <li>Category K: Inferences drawn of other personal information.</li>
    </ul>
    <p>
      We disclose your personal information for a business purpose to the
      following categories of third parties: Our affiliates.
    </p>
    <p class="title">Service providers.</p>
    <p>
      Third parties to whom our customers have authorized us to disclose their
      personal information in connection to services we provide to them. In the
      preceding twelve (12) months, we have not sold any personal information.
    </p>
    <p class="title">Your Rights and Choices</p>
    <p>
      The CCPA provides California residents with specific rights regarding
      their personal information. This section describes your CCPA rights and
      explains how to exercise those rights.
    </p>
    <p class="title">Access to Specific Information and Data Portability Rights</p>
    <p>
      You have the right to request that we disclose certain information to you
      about our collection and use of your personal information over the past 12
      months. Once we receive and confirm your verifiable consumer request, we
      will disclose to you: The categories of personal information we collected
      about you. The categories of sources for the personal information we
      collected about you. Our business or commercial purpose for collecting or
      selling that personal information. The categories of third parties with
      whom we share that personal information. The specific pieces of personal
      information we collected about you (also called a data portability
      request). If we sold or disclosed your personal information for a business
      purpose, two separate lists disclosing: sales, identifying the personal
      information categories that each category of recipient purchased; and
      disclosures for a business purpose, identifying the personal information
      categories that each category of recipient obtained.
    </p>
    <p>
      California Civil Code Section 1798.83 entitles California users to request
      information concerning whether a business has disclosed certain
      information about you to any third parties for the third parties’ direct
      marketing purposes. California users who wish to request further
      information in compliance with this law or have questions or concerns
      about our privacy practices and policies may contact us as specified in
      the “How to Contact Us” section below.
    </p>
    <p class="title">Deletion Request Rights</p>
    <p>
      You have the right to request that we delete any of your personal
      information that we collected about you and retained, subject to certain
      exceptions in the CCPA. Once we receive and confirm your verifiable
      consumer request, we will delete your personal information from our
      records, unless an exception applies, and we will direct our service
      providers to similarly delete your personal information from their
      records.
    </p>
    <p class="title">Exercising Access, Data Portability, and Deletion Rights</p>
    <p>
      To exercise the access, data portability, and deletion rights described
      above, please submit a “verifiable consumer request” (defined below) to us
      by calling us at (888) 542-0844.
    </p>
    <p>
      Only you or someone you authorized to act on your behalf, may make a
      verifiable consumer request related to your personal information. You may
      also make a verifiable consumer request on behalf of your minor child. A
      verifiable consumer request must Provide enough information that allows us
      to reasonably verify you are the person about whom we collected personal
      information or an authorized representative; and Describe your request
      with enough detail that allows us to properly understand, evaluate, and
      respond to it. You may only make a verifiable consumer request for access
      or data portability twice within a 12-month period. We cannot respond to
      your request or provide you with personal information if we cannot verify
      your identity or authority to make the request and confirm the personal
      information relates to you. Making a verifiable consumer request does not
      require you to create an account with us. We will only use personal
      information provided in a verifiable consumer request to verify the
      requestor's identity or authority to make the request.
    </p>
    <p class="title">Non-Discrimination</p>
    <p>
      We will not discriminate against you for exercising any of your CCPA
      rights. Unless permitted by the CCPA, we will not deny you goods or
      services, charge you different prices or rates for goods or services,
      including through granting discounts or other benefits, or imposing
      penalties, provide you a different level or quality of goods or services,
      or suggest that you may receive a different price or rate for goods or
      services or a different level or quality of goods or services.
    </p>
    <p class="title">Do Not Track</p>
    <p>
      Online Tracking Policy for California Residents. As of the effective date
      of this Privacy Statement, there is no commonly accepted response for Do
      Not Track signals initiated by browsers, therefore we do not respond to
      them.
    </p>
    <p class="title">
     Contact information
    </p>
    <p>
      If you have any questions or comments about this notice, our Privacy
      Statement, the ways in which we collect and use your personal information,
      your choices and rights regarding such use, or wish to exercise your
      rights under California law, please do not hesitate to contact us at:
      <br />
      Website:
      <f7-link external target="_blank" href="http://www.buildabrand.com"
        >http://www.buildabrand.com</f7-link
      >
      <br />
      Email:
      <f7-link external href="mailto:support@buildabrand.com"
        >support@buildabrand.com</f7-link
      >
      <br />
      Address:
      <f7-link
        external
        target="_blank"
        href="https://maps.app.goo.gl/mDFr7YESetvqEJCX7"
        >Build-A-Brand, 7280 Craft Goodman Rd, Olive Branch MS 38654</f7-link
      >
    </p>
    <a class="button_full btyellow" v-on:click="back" :style="borderStyle"
      >Back</a
    >
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'privacy-policy',
  methods: {
    back () {
      this.$emit('goback', 'click')
    }
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn
        ? 'solid 1px ' + this.customization.borderColor
        : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  }
}
</script>
<style scoped>
ul {
  list-style: disc;
  padding-left: 25px;
  padding-top: 10px;
}

ul.simple {
  list-style: none;
}

.title{
  font-weight: 600;
}

.uppercase{
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// privacy-policy.vue?04344b8a